// extracted by mini-css-extract-plugin
export default {"title":"styles_title__dRHPO","accent":"styles_accent__zzlFE","advantages":"styles_advantages__yzNjf"};